import { jsonProperty, Serializable } from 'ts-serializable';

export class TipoModeloSecao extends Serializable {
    @jsonProperty(Number)
    codigo: number = -1;

    @jsonProperty(String)
    titulo: string = '';
}
